import { render } from "./HealthCard.vue?vue&type=template&id=e6ec8bf8"
import script from "./HealthCard.vue?vue&type=script&lang=js"
export * from "./HealthCard.vue?vue&type=script&lang=js"

import "./HealthCard.vue?vue&type=style&index=0&id=e6ec8bf8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__